// TODO - remove lint disable when editing this file
/* eslint-disable */
import { get } from 'lodash'

// Handling both section type and reference type of section
export const getSectionId = (section) => {
  return get(section, '_id', get(section, 'referent.id'))
}

export const getSectionWebsite = (section) => {
  return get(section, '_website', get(section, 'referent.website'))
}
